import React from 'react';
import styled from 'styled-components';

import shop from 'Images/join-bys.jpg';
import save from 'Images/shop-online.png';
import grow from 'Images/get-paid.jpg';

import styles from './index.css';

const HowItWorksWrapper = styled.div`${styles}`;

const HowItWorks = ({ content }) => (
  <HowItWorksWrapper className="hide-scrollbars" id="how-it-works">
    <h2>{content.how_it_works_heading}</h2>
    <div className="how-it-works-card">
      <h1>{content.how_it_works_heading1}</h1>
      <div className="value-proposition"> 
        <p>{content.how_it_works_value_proposition}</p>
      </div>
      <div className="steps-container">
        <div className="step">
          <div className="icon-container">
            <img src={content.how_it_works_image_1} alt="shop" />
          </div>
          <div className="description">
              <b className="title">{content.how_it_works_step_1}</b>
            <span className="text">{content.how_it_works_text_1}</span>
          </div>
        </div>
        <div className="arrow">
          <i className="material-icons">keyboard_backspace</i>
        </div>
        <div className="step">
          <div className="icon-container">
            <img src={content.how_it_works_image_2} alt="shop" />
          </div>
          <div className="description">
              <b className="title">{content.how_it_works_step_2}</b>
            <span className="text">{content.how_it_works_text_2}</span>
          </div>
        </div>
        <div className="arrow">
          <i className="material-icons">keyboard_backspace</i>
        </div>
        <div className="step">
          <div className="icon-container">
            <img src={content.how_it_works_image_3} alt="shop" />
          </div>
          <div className="description">
              <b className="title">{content.how_it_works_step_3}</b>
            <span className="text">{content.how_it_works_text_3}</span>
          </div>
        </div>
      </div>
    </div>
    <hr className="horizontal-rule"/>
    <div className="how-it-works-card">
      <h1>{content.how_it_works2_heading1}</h1>
      <div className="value-proposition"> 
        <p>{content.how_it_works2_value_proposition}</p>
      </div>
      <div className="steps-container">
        <div className="step">
          <div className="icon-container">
            <img src={content.how_it_works2_image_1} alt="shop" />
          </div>
          <div className="description">
              <b className="title">{content.how_it_works2_step_1}</b>
            <span className="text">{content.how_it_works2_text_1}</span>
          </div>
        </div>
        <div className="arrow">
          <i className="material-icons">keyboard_backspace</i>
        </div>
        <div className="step">
          <div className="icon-container">
            <img src={content.how_it_works2_image_2} alt="shop" />
          </div>
          <div className="description">
              <b className="title">{content.how_it_works2_step_2}</b>
            <span className="text">{content.how_it_works2_text_2}</span>
          </div>
        </div>
        <div className="arrow">
          <i className="material-icons">keyboard_backspace</i>
        </div>
        <div className="step">
          <div className="icon-container">
            <img src={content.how_it_works2_image_3} alt="shop" />
          </div>
          <div className="description">
              <b className="title">{content.how_it_works2_step_3}</b>
            <span className="text">{content.how_it_works2_text_3}</span>
          </div>
        </div>
      </div>
    </div>
  </HowItWorksWrapper>
);

export default HowItWorks;
